/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Icd10Code } from './Icd10Code';
import {
    Icd10CodeFromJSON,
    Icd10CodeFromJSONTyped,
    Icd10CodeToJSON,
} from './Icd10Code';

/**
 * 
 * @export
 * @interface FindAllIcd10CodesResponse
 */
export interface FindAllIcd10CodesResponse {
    /**
     * 
     * @type {Array<Icd10Code>}
     * @memberof FindAllIcd10CodesResponse
     */
    data: Array<Icd10Code>;
    /**
     * 
     * @type {number}
     * @memberof FindAllIcd10CodesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllIcd10CodesResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllIcd10CodesResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllIcd10CodesResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllIcd10CodesResponse interface.
 */
export function instanceOfFindAllIcd10CodesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllIcd10CodesResponseFromJSON(json: any): FindAllIcd10CodesResponse {
    return FindAllIcd10CodesResponseFromJSONTyped(json, false);
}

export function FindAllIcd10CodesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIcd10CodesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(Icd10CodeFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllIcd10CodesResponseToJSON(value?: FindAllIcd10CodesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(Icd10CodeToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

